import http from './reddit'
// personalCenter
export default {
  // 个人资料
  ifma: (loid, lomlv) => http.Get(`${http.url.Newcommon}/ifma/${loid}/${lomlv}`),
  // 彩票预设值
  accmsdv: (gameid) => http.Get(`${http.url.hfl}/accmsdv/${gameid}`),
  // 總管理登录紀錄
  ifadlog: (pid)=> http.Get(`${http.url.Newcommon}/ifadlog/${pid}`),
  // 修改密码
  fixpass:(data) => http.Post(`${http.url.Newcommon}/pwu`,data),
}